export const ordersFilter = {
  name: "ordersFilter",
  criterions: [
    {
      $id: "6",
      monthToBack: 1,
      fromDataType: 4,
      toDataType: 0,
      value: {
        $id: "7",
        fromIsSelected: true,
        fromValue: "2020-12-01T00:00:00",
        toIsSelected: false,
        toValue: "2021-01-15T00:00:00",
      },
      type: "DateFromToCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres",
      propertyName: "Period",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "8",
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          $id: "9",
          intKey: 1,
          stringKey: null,
          stringValue: "Ostatnia modyfikacja",
          tooltipValue: "",
        },
        {
          $id: "10",
          intKey: 2,
          stringKey: null,
          stringValue: "Utworzone w systemie",
          tooltipValue: "",
        },
        {
          $id: "11",
          intKey: 3,
          stringKey: null,
          stringValue: "Utworzone u operatora",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        $id: "12",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres po",
      propertyName: "DatePeriodFilter",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "13",
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Nr biletu/rez.",
      propertyName: "TicketNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "14",
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Nazwisko pasażera",
      propertyName: "PassengerName",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "15",
      extension: null,
      width: 200,
      value: null,
      uniqueId: null,
      type: "AutocompleteTextCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 4,
      label: "Kontrahent",
      propertyName: "propertyName_ContractorsAutocompleteOnlyBuyers",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "16",
      extension: null,
      width: 200,
      enumCriterionType: 0,
      enumCriterionOwnerItems: [
        {
          $id: "17",
          ownerId: 0,
          intKey: 0,
          stringKey: "00000000-0000-0000-0000-000000000000",
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          $id: "18",
          ownerId: 118,
          intKey: 0,
          stringKey: "6f9f3d55-525c-4848-9877-fc89fb411596",
          stringValue: "",
          tooltipValue: "",
        },
        {
          $id: "19",
          ownerId: 132,
          intKey: 0,
          stringKey: "79a5539a-8959-4d04-96c8-1601a1f016e1",
          stringValue: "",
          tooltipValue: "",
        },
        {
          $id: "20",
          ownerId: 94,
          intKey: 0,
          stringKey: "7c3aab47-e78a-47ad-9d13-5f661c21e1bb",
          stringValue: "Agnieszka Jaworska",
          tooltipValue: "",
        },
        {
          $id: "21",
          ownerId: 114,
          intKey: 0,
          stringKey: "50c3ba3e-9bfd-40f6-a0cd-3f37f19130da",
          stringValue: "Agnieszka Tybuszewska",
          tooltipValue: "",
        },
        {
          $id: "22",
          ownerId: 83,
          intKey: 0,
          stringKey: "91de27dd-95ef-474a-bd6f-62f8d63f64c0",
          stringValue: "Alicja Ślemp",
          tooltipValue: "",
        },
        {
          $id: "23",
          ownerId: 100,
          intKey: 0,
          stringKey: "b71120a5-acf8-41c0-90f6-9937d6e81c01",
          stringValue: "Alicja Tutak",
          tooltipValue: "",
        },
        {
          $id: "24",
          ownerId: 270,
          intKey: 0,
          stringKey: "a81cfcd7-1fae-4f95-a066-f06a8d363a0d",
          stringValue: "Andżelika Kulik",
          tooltipValue: "",
        },
        {
          $id: "25",
          ownerId: 161,
          intKey: 0,
          stringKey: "5975362e-a176-42b0-95e7-64a2a1786a6d",
          stringValue: "Aneta Nowak",
          tooltipValue: "",
        },
        {
          $id: "26",
          ownerId: 232,
          intKey: 0,
          stringKey: "0751a92c-dadd-4e83-87c4-3b9a53e3a9a3",
          stringValue: "Angela Virstyuk",
          tooltipValue: "",
        },
        {
          $id: "27",
          ownerId: 189,
          intKey: 0,
          stringKey: "335c8f3f-4ef4-410c-94a4-9936626b3d9a",
          stringValue: "Angelika Giżka",
          tooltipValue: "",
        },
        {
          $id: "28",
          ownerId: 262,
          intKey: 0,
          stringKey: "2a3db0b5-8849-4daf-9eef-d7f4cb35c9e2",
          stringValue: "Anna Augustyn-Wacha",
          tooltipValue: "",
        },
        {
          $id: "29",
          ownerId: 134,
          intKey: 0,
          stringKey: "b76a4133-0912-46cc-9d0c-5833a9e0dd1e",
          stringValue: "Anna Paradowska",
          tooltipValue: "",
        },
        {
          $id: "30",
          ownerId: 127,
          intKey: 0,
          stringKey: "1c0069cb-1ffd-416e-aee0-29bc6e23c290",
          stringValue: "Anna Pawlik-Kuś",
          tooltipValue: "",
        },
        {
          $id: "31",
          ownerId: 88,
          intKey: 0,
          stringKey: "af82b39d-9374-4c7a-9a17-f1f7303cd3cf",
          stringValue: "Anna Szczudlik",
          tooltipValue: "",
        },
        {
          $id: "32",
          ownerId: 135,
          intKey: 0,
          stringKey: "a02bfefe-d7dd-483b-b62e-d01db8a39c60",
          stringValue: "Anna Wójcik",
          tooltipValue: "",
        },
        {
          $id: "33",
          ownerId: 209,
          intKey: 0,
          stringKey: "ea97f9a1-7a1a-4520-8ca6-8b096160fc33",
          stringValue: "Barbara Bąk",
          tooltipValue: "",
        },
        {
          $id: "34",
          ownerId: 85,
          intKey: 0,
          stringKey: "900dcaa2-355e-4543-9b41-512915be2d69",
          stringValue: "Barbara Micał",
          tooltipValue: "",
        },
        {
          $id: "35",
          ownerId: 5,
          intKey: 0,
          stringKey: "375e763d-3d2c-4517-b487-8d7997da12d1",
          stringValue: "Beata Malec",
          tooltipValue: "",
        },
        {
          $id: "36",
          ownerId: 239,
          intKey: 0,
          stringKey: "f5100167-66cb-4ae8-a7bf-607bf7f5df35",
          stringValue: "Beata Sienko",
          tooltipValue: "",
        },
        {
          $id: "37",
          ownerId: 218,
          intKey: 0,
          stringKey: "8f06dbe9-0cfc-4cce-9113-b11422b3d3b6",
          stringValue: "Dagny Chrenkoff-Bączyńska",
          tooltipValue: "",
        },
        {
          $id: "38",
          ownerId: 205,
          intKey: 0,
          stringKey: "8dfadc19-a395-4951-8259-1263e0434f80",
          stringValue: "Elżbieta Chrzan",
          tooltipValue: "",
        },
        {
          $id: "39",
          ownerId: 177,
          intKey: 0,
          stringKey: "0c56942c-70b6-40cc-bf59-aceb55285a5c",
          stringValue: "Emergency",
          tooltipValue: "",
        },
        {
          $id: "40",
          ownerId: 6,
          intKey: 0,
          stringKey: "6201679d-23f2-4115-959f-18e3ccfc4bde",
          stringValue: "Ewa Bednarek",
          tooltipValue: "",
        },
        {
          $id: "41",
          ownerId: 120,
          intKey: 0,
          stringKey: "3b5ee31f-e485-4ceb-a979-2325c8c11186",
          stringValue: "Ewelina Madejczyk",
          tooltipValue: "",
        },
        {
          $id: "42",
          ownerId: 263,
          intKey: 0,
          stringKey: "eb16cc45-187a-44a9-9fca-62805c5b5be2",
          stringValue: "Grupa Hotele",
          tooltipValue: "",
        },
        {
          $id: "43",
          ownerId: 264,
          intKey: 0,
          stringKey: "035becac-e1dd-4d0e-a016-32d6ebab5291",
          stringValue: "Grupa Logistyka",
          tooltipValue: "",
        },
        {
          $id: "44",
          ownerId: 253,
          intKey: 0,
          stringKey: "39e9aa8c-ecd4-4881-90e6-efeee4b86a9d",
          stringValue: "Izabela Maleszka",
          tooltipValue: "",
        },
        {
          $id: "45",
          ownerId: 213,
          intKey: 0,
          stringKey: "03de0032-f1ca-4348-96c2-9eebdf8ee264",
          stringValue: "Izabela Matuszczak",
          tooltipValue: "",
        },
        {
          $id: "46",
          ownerId: 179,
          intKey: 0,
          stringKey: "6a8cb67a-479e-4a06-af04-dcd013830863",
          stringValue: "Jakub Nestorowicz",
          tooltipValue: "",
        },
        {
          $id: "47",
          ownerId: 4,
          intKey: 0,
          stringKey: "91b5393e-ae1c-40ba-abcc-9927b672d85a",
          stringValue: "Joanna Smalec",
          tooltipValue: "",
        },
        {
          $id: "48",
          ownerId: 10,
          intKey: 0,
          stringKey: "075063e2-bb69-4ae7-9cf1-c76260451934",
          stringValue: "Kamil Stec",
          tooltipValue: "",
        },
        {
          $id: "49",
          ownerId: 219,
          intKey: 0,
          stringKey: "74bc92b7-528e-45b6-b172-e1b1daaeb6c8",
          stringValue: "Kasjer hotelowy",
          tooltipValue: "",
        },
        {
          $id: "50",
          ownerId: 265,
          intKey: 0,
          stringKey: "c6d34963-a71f-4d32-94ab-19134e60777f",
          stringValue: "Kasjerzy Kielnarowa",
          tooltipValue: "",
        },
        {
          $id: "51",
          ownerId: 266,
          intKey: 0,
          stringKey: "bda102d6-b440-4925-91ef-87f7e5507b7e",
          stringValue: "Kasjerzy Rzeszów",
          tooltipValue: "",
        },
        {
          $id: "52",
          ownerId: 9,
          intKey: 0,
          stringKey: "b5d967c9-2bf5-402a-b64b-c14400efaf68",
          stringValue: "Katarzyna Lutomska",
          tooltipValue: "",
        },
        {
          $id: "53",
          ownerId: 241,
          intKey: 0,
          stringKey: "4871afe7-30f1-4736-8ca5-78198c9d5e63",
          stringValue: "Katrzyna Żuryło",
          tooltipValue: "",
        },
        {
          $id: "54",
          ownerId: 82,
          intKey: 0,
          stringKey: "5ffb3eeb-7b23-4231-8caf-43476320efc9",
          stringValue: "Kinga Guz",
          tooltipValue: "",
        },
        {
          $id: "55",
          ownerId: 78,
          intKey: 0,
          stringKey: "b85900aa-a514-4d0e-8e02-e8caa959c1e5",
          stringValue: "Klaudia Padwińska",
          tooltipValue: "",
        },
        {
          $id: "56",
          ownerId: 244,
          intKey: 0,
          stringKey: "a9f5a617-da2d-40df-9d16-598edb12d78b",
          stringValue: "Konrad Tarczyński",
          tooltipValue: "",
        },
        {
          $id: "57",
          ownerId: 11,
          intKey: 0,
          stringKey: "2308ae86-5112-40e2-b4bc-581b8ba91add",
          stringValue: "Krystyna Szela",
          tooltipValue: "",
        },
        {
          $id: "58",
          ownerId: 98,
          intKey: 0,
          stringKey: "687d7163-85a9-40a7-85a4-86175bd4b5d0",
          stringValue: "Krzysztof Murias",
          tooltipValue: "",
        },
        {
          $id: "59",
          ownerId: 12,
          intKey: 0,
          stringKey: "6072d51d-02b4-4940-933f-01f6955dcd2b",
          stringValue: "Lidia Socha",
          tooltipValue: "",
        },
        {
          $id: "60",
          ownerId: 101,
          intKey: 0,
          stringKey: "274dd604-f736-483b-bf5b-9a9fcb8534ed",
          stringValue: "Łukasz Reizer",
          tooltipValue: "",
        },
        {
          $id: "61",
          ownerId: 16,
          intKey: 0,
          stringKey: "0f290f2a-daab-4178-9819-095e17588fbb",
          stringValue: "Maciej Szczudlik",
          tooltipValue: "",
        },
        {
          $id: "62",
          ownerId: 199,
          intKey: 0,
          stringKey: "9db33240-108d-44de-aaf7-cde87d6736a9",
          stringValue: "Magdalena Ziomek",
          tooltipValue: "",
        },
        {
          $id: "63",
          ownerId: 204,
          intKey: 0,
          stringKey: "df3ee048-1ccd-46cb-9726-f21cae402395",
          stringValue: "Małgorzata Lew",
          tooltipValue: "",
        },
        {
          $id: "64",
          ownerId: 13,
          intKey: 0,
          stringKey: "dd17a258-931c-4985-9189-3ecf7dec5d46",
          stringValue: "Małgorzata Lorenc",
          tooltipValue: "",
        },
        {
          $id: "65",
          ownerId: 166,
          intKey: 0,
          stringKey: "2f8c89d7-fc0d-491e-a0cb-a90bec6787c4",
          stringValue: "Małgorzata Winiecka",
          tooltipValue: "",
        },
        {
          $id: "66",
          ownerId: 107,
          intKey: 0,
          stringKey: "42351e85-601e-4ac0-8e6f-02eece3178c5",
          stringValue: "Marianna Giefert",
          tooltipValue: "",
        },
        {
          $id: "67",
          ownerId: 87,
          intKey: 0,
          stringKey: "23ebf09c-f895-4908-a623-8755a9903c2d",
          stringValue: "Marta Trojanowska",
          tooltipValue: "",
        },
        {
          $id: "68",
          ownerId: 141,
          intKey: 0,
          stringKey: "240accc4-a8a0-41f2-b35f-0178217aee5f",
          stringValue: "Marzena Machnicka",
          tooltipValue: "",
        },
        {
          $id: "69",
          ownerId: 210,
          intKey: 0,
          stringKey: "84443f59-b20a-4d93-bbd8-ede20fd03dba",
          stringValue: "Monika Kuźniar",
          tooltipValue: "",
        },
        {
          $id: "70",
          ownerId: 128,
          intKey: 0,
          stringKey: "a2a4df2d-291a-4cfc-8b98-e3f85d5719ce",
          stringValue: "Monika Lachtara",
          tooltipValue: "",
        },
        {
          $id: "71",
          ownerId: 86,
          intKey: 0,
          stringKey: "6656a3c7-2ac0-4408-b505-c232c8cbd912",
          stringValue: "Monika Sarna",
          tooltipValue: "",
        },
        {
          $id: "72",
          ownerId: 53,
          intKey: 0,
          stringKey: "4eab3ca3-4cd2-4bba-b046-319e0c40a197",
          stringValue: "NON IATA",
          tooltipValue: "",
        },
        {
          $id: "73",
          ownerId: 196,
          intKey: 0,
          stringKey: "2adce796-8e3f-4a5f-b6c0-7e4ce5090f7c",
          stringValue: "Patrycja Pokusa",
          tooltipValue: "",
        },
        {
          $id: "74",
          ownerId: 237,
          intKey: 0,
          stringKey: "287d78ea-29f1-41bd-a994-d96aed48f495",
          stringValue: "Patrycja Preneta",
          tooltipValue: "",
        },
        {
          $id: "75",
          ownerId: 260,
          intKey: 0,
          stringKey: "0d716689-d4e2-48c5-9297-0a044505ce66",
          stringValue: "Patrycja Ryczkowska",
          tooltipValue: "",
        },
        {
          $id: "76",
          ownerId: 123,
          intKey: 0,
          stringKey: "ae63c10f-a7de-4c21-b2fb-54116f3126f9",
          stringValue: "Paweł Balawender ",
          tooltipValue: "",
        },
        {
          $id: "77",
          ownerId: 129,
          intKey: 0,
          stringKey: "6f9f3be0-8f9f-4741-a010-baf657ff818b",
          stringValue: "Piotr Trentowski",
          tooltipValue: "",
        },
        {
          $id: "78",
          ownerId: 223,
          intKey: 0,
          stringKey: "3ff2b195-209c-41b4-8c4a-fba5f4d923fa",
          stringValue: "Przemysław Kijowski",
          tooltipValue: "",
        },
        {
          $id: "79",
          ownerId: 190,
          intKey: 0,
          stringKey: "cf055e46-1f06-49f8-b854-ebf3dc07945b",
          stringValue: "Sabina Kłosowska",
          tooltipValue: "",
        },
        {
          $id: "80",
          ownerId: 193,
          intKey: 0,
          stringKey: "1b2a9090-df16-445a-b65a-7260184c96bf",
          stringValue: "Sabina Żurek",
          tooltipValue: "",
        },
        {
          $id: "81",
          ownerId: 90,
          intKey: 0,
          stringKey: "43ac6600-bd52-4241-99cc-0a167c88f91b",
          stringValue: "Sylwia Janaś",
          tooltipValue: "",
        },
        {
          $id: "82",
          ownerId: 113,
          intKey: 0,
          stringKey: "84b96e17-3024-4a53-af08-679150d38087",
          stringValue: "Tomasz Gudzio",
          tooltipValue: "",
        },
        {
          $id: "83",
          ownerId: 170,
          intKey: 0,
          stringKey: "f96e27cb-265b-4a0a-8ce2-50a9c00d8df5",
          stringValue: "Wioletta Chochorowska",
          tooltipValue: "",
        },
        {
          $id: "84",
          ownerId: 160,
          intKey: 0,
          stringKey: "03034613-eee2-4c0a-bf08-73b0f1d794ff",
          stringValue: "Wioletta Kucharzyk",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        $ref: "17",
      },
      booleanExtender: null,
      value: {
        $id: "85",
        intKey: 0,
        stringKey: null,
        stringValue: null,
        ownerId: 0,
      },
      type: "EnumOwnerCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 5,
      label: "Kasjer",
      propertyName: "Cashier",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "86",
      extension: null,
      placeholder: "",
      width: 100,
      value: null,
      type: "TextCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 6,
      label: "Cena",
      propertyName: "GrandTotal",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      $id: "87",
      extension: null,
      width: 120,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          $id: "88",
          intKey: 0,
          stringKey: null,
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          $id: "89",
          intKey: 1,
          stringKey: null,
          stringValue: "Z fakturą",
          tooltipValue: "",
        },
        {
          $id: "90",
          intKey: 2,
          stringKey: null,
          stringValue: "Bez faktury",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        $ref: "89",
      },
      booleanExtender: null,
      value: {
        $id: "91",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 7,
      label: "Posiada dokument kosztowy",
      propertyName: "HasCostDocument",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      $id: "92",
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 8,
      label: "Kod agenta",
      propertyName: "AgentCode",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      $id: "93",
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          $id: "94",
          intKey: 0,
          stringKey: "MA",
          stringValue: "Manual",
          tooltipValue: "",
        },
        {
          $id: "95",
          intKey: 0,
          stringKey: "1A",
          stringValue: "Amadeus",
          tooltipValue: "",
        },
        {
          $id: "96",
          intKey: 0,
          stringKey: "1G",
          stringValue: "Galileo",
          tooltipValue: "",
        },
        {
          $id: "97",
          intKey: 0,
          stringKey: "1S",
          stringValue: "Sabre",
          tooltipValue: "",
        },
        {
          $id: "98",
          intKey: 0,
          stringKey: "1P",
          stringValue: "Worldspan",
          tooltipValue: "",
        },
        {
          $id: "99",
          intKey: 0,
          stringKey: "TR",
          stringValue: "Tripnet",
          tooltipValue: "",
        },
        {
          $id: "100",
          intKey: 0,
          stringKey: "LC",
          stringValue: "Lowcost",
          tooltipValue: "",
        },
        {
          $id: "101",
          intKey: 0,
          stringKey: "1H",
          stringValue: "HRS",
          tooltipValue: "",
        },
        {
          $id: "102",
          intKey: 0,
          stringKey: "2H",
          stringValue: "Horse21",
          tooltipValue: "",
        },
        {
          $id: "103",
          intKey: 0,
          stringKey: "SP",
          stringValue: "Spark",
          tooltipValue: "",
        },
        {
          $id: "104",
          intKey: 0,
          stringKey: "1R",
          stringValue: "Rail",
          tooltipValue: "",
        },
        {
          $id: "105",
          intKey: 0,
          stringKey: "BC",
          stringValue: "Booking.com",
          tooltipValue: "",
        },
        {
          $id: "106",
          intKey: 0,
          stringKey: "GG",
          stringValue: "GoGlobal",
          tooltipValue: "",
        },
        {
          $id: "107",
          intKey: 0,
          stringKey: "CI",
          stringValue: "Content Inn",
          tooltipValue: "",
        },
        {
          $id: "108",
          intKey: 0,
          stringKey: "AC",
          stringValue: "Accor",
          tooltipValue: "",
        },
        {
          $id: "109",
          intKey: 0,
          stringKey: "IH",
          stringValue: "Bezpośrednio w hotelu",
          tooltipValue: "",
        },
        {
          $id: "110",
          intKey: 0,
          stringKey: "SI",
          stringValue: "Signal Iduna",
          tooltipValue: "",
        },
        {
          $id: "111",
          intKey: 0,
          stringKey: "RA",
          stringValue: "Ratehawk",
          tooltipValue: "",
        },
        {
          $id: "112",
          intKey: 0,
          stringKey: "XC",
          stringValue: "xTurConnector",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        $ref: "94",
      },
      booleanExtender: null,
      value: {
        $id: "113",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 9,
      label: "Op.",
      propertyName: "GDS",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      $id: "114",
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          $id: "115",
          intKey: -1,
          stringKey: null,
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          $id: "116",
          intKey: 0,
          stringKey: null,
          stringValue: "Niegotowa",
          tooltipValue: "",
        },
        {
          $id: "117",
          intKey: 1,
          stringKey: null,
          stringValue: "Częściowo gotowa",
          tooltipValue: "",
        },
        {
          $id: "118",
          intKey: 2,
          stringKey: null,
          stringValue: "Gotowa",
          tooltipValue: "",
        },
        {
          $id: "119",
          intKey: 3,
          stringKey: null,
          stringValue: "Gotowa - zablokowana",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        $ref: "118",
      },
      booleanExtender: null,
      value: {
        $id: "120",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 10,
      label: "Status rez.",
      propertyName: "BookingItemStatus",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      $id: "121",
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          $id: "122",
          intKey: 0,
          stringKey: null,
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          $id: "123",
          intKey: 3,
          stringKey: null,
          stringValue: "WNU Rzeszów",
          tooltipValue: "",
        },
        {
          $id: "124",
          intKey: 5,
          stringKey: null,
          stringValue: "WNU Warszawa",
          tooltipValue: "",
        },
        {
          $id: "125",
          intKey: 6,
          stringKey: null,
          stringValue: "WNU Kraków",
          tooltipValue: "",
        },
        {
          $id: "126",
          intKey: 7,
          stringKey: null,
          stringValue: "WNU Lublin",
          tooltipValue: "",
        },
        {
          $id: "127",
          intKey: 8,
          stringKey: null,
          stringValue: "WNU Krosno",
          tooltipValue: "",
        },
        {
          $id: "128",
          intKey: 14,
          stringKey: null,
          stringValue: "WNU RZE2",
          tooltipValue: "",
        },
        {
          $id: "129",
          intKey: 19,
          stringKey: null,
          stringValue: "WNU Kongres",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        $ref: "122",
      },
      booleanExtender: null,
      value: {
        $id: "130",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      version: 3,
      extensionType: null,
      extensionValue: null,
      ordinate: 11,
      label: "Oddział",
      propertyName: "Department",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
  ],
};
